import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import Model3DViewer from '../components/Model3DViewer';
import { configService } from '../services/ConfigService';
import '../styles/Dimensions.css';

function DimensionsDynamic() {
  const { slug } = useParams<{ slug: string }>();
  const [boothConfig, setBoothConfig] = useState<any>(null);

  useEffect(() => {
    const config = configService.getBooth(slug || '');
    setBoothConfig(config);
  }, [slug]);

  if (!boothConfig) {
    return <div>جاري التحميل...</div>;
  }

  // Fallback to classic/modern paths for backward compatibility
  const modelSrc = boothConfig.modelUrl || (slug === 'classic' ? '/models/booth-classic.glb' : slug === 'modern' ? '/models/booth-modern.glb' : null);
  const iosSrc = boothConfig.iosModelUrl || (slug === 'classic' ? '/models/Booth-Classic.usdz' : slug === 'modern' ? '/models/Booth-Modern.usdz' : null);

  return (
    <motion.div 
      className="dimensions-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <img src="/images/logo.png" alt="Fotomista" />
          </div>
          <ul className="nav-menu">
            <li><Link to="/">الرئيسية</Link></li>
            <li><Link to="/contact">اتصل بنا</Link></li>
          </ul>
        </div>
      </nav>

      <section className="dimensions-hero">
        <h1>{boothConfig?.name} - المقاسات ونموذج 3D</h1>

        <div className="dimensions-content">
          <div className="model-3d" id="3d-model">
            <div className="model-header">
              <h2>نموذج 3D</h2>
              <div id="ar-button-container"></div>
            </div>
            <div className="model-placeholder">
              {modelSrc ? (
                <Model3DViewer
                  modelSrc={modelSrc}
                  iosSrc={iosSrc}
                  alt={boothConfig?.name + " ثلاثية الأبعاد"}
                />
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', background: '#f5f5f5', borderRadius: '15px', position: 'relative' }}>
                  <img src={boothConfig.imageUrl || (slug === 'classic' ? '/images/Booth-Classic.png' : '/images/Booth-Modern.png')} alt={boothConfig.name} style={{ maxHeight: '80%', objectFit: 'contain', opacity: 0.5 }} />
                  <div style={{ position: 'absolute', background: 'rgba(0,0,0,0.7)', color: 'white', padding: '10px 20px', borderRadius: '30px', fontWeight: 'bold', fontSize: '1.2rem' }}>
                    سيتوفر قريباً
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="dimensions-info" id="dimensions">
            <h2>المقاسات</h2>
            <div className="dimensions-grid">
              <div className="dimension-item">
                <span className="dimension-label">الارتفاع:</span>
                <span className="dimension-value">{boothConfig.dimensions?.height || 200} سم</span>
              </div>
              <div className="dimension-item">
                <span className="dimension-label">العرض:</span>
                <span className="dimension-value">{boothConfig.dimensions?.width || 120} سم</span>
              </div>
              <div className="dimension-item">
                <span className="dimension-label">العمق:</span>
                <span className="dimension-value">{boothConfig.dimensions?.depth || 150} سم</span>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <Link to={`/booking/${slug}`} className="btn-primary">احجز الآن</Link>
          <Link to="/" className="btn-secondary">رجوع للرئيسية</Link>
        </div>
      </section>
    </motion.div>
  );
}

export default DimensionsDynamic;
